import { render, staticRenderFns } from "./ThePersonalSupportCard.vue?vue&type=template&id=26b43b24&"
import script from "./ThePersonalSupportCard.vue?vue&type=script&lang=js&"
export * from "./ThePersonalSupportCard.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalSupportCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports